import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { HomePage } from '../../pages/home/home';

@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html'
})
export class WelcomePage {

  constructor(public navCtrl: NavController,public _DataProvider: DataProvider) {
    this._DataProvider.currentPage = 'welcome'
    this._DataProvider.menuShow = true;

  }

  multi = false
  ngOnInit(){
    this.gotoMuzium("onu")
  }
  

  gotoMuzium(urlCode){
    this._DataProvider.getMuzeumByurlCodeFB(urlCode).subscribe((res:any) => {
      console.log("TopMenuComponent---res",res);
      console.log("TopMenuComponent---res",res.length);
      if(res.length != 0){
        this._DataProvider.Muzeum = res[0];
   
        this.navCtrl.setRoot(HomePage, {
          muzeum:urlCode,
        });
      }
    });

  }


}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts